import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, Link as RouterLink } from 'react-router-dom';
import {
    Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    TextField, Button, LinearProgress, FormControl, Typography, List, ListItem, ListItemText, ListItemIcon
} from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { openSendConfirmationEmailDialog, sendConfirmationEmail } from '../../actions/webAccountUserDetails';
import { useTranslation } from 'react-i18next';
import useUser from '../../user/useUser';
import * as constants from '../../constants';

const SendWebAccountUserConfirmationEmailDialog = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const location = window.location;
    const { user, token, unsetUser } = useUser();
    const loading = useSelector(state => state.global.loading);
    const webAccountUser = useSelector(state => state.webAccountUserDetails.webAccountUser);
    const sendConfirmationEmailDialog = useSelector(state => state.webAccountUserDetails.sendConfirmationEmailDialog);
    const generalErrorText = useSelector(state => state.webAccountUserDetails.generalErrorText);
    const dispatch = useDispatch();
    const language = i18n.languages[0];

    return (
        <Dialog
            disableBackdropClick={loading}
            open={sendConfirmationEmailDialog.isOpen}
            onClose={() => dispatch(openSendConfirmationEmailDialog(false))}>
            <DialogTitle>{t("SendConfirmationEmail")}</DialogTitle>
            <DialogContent>

                {loading ? <LinearProgress style={{ height: 3 }} /> : <div style={{ height: 3 }} />}

                {generalErrorText ? <Alert style={{ marginTop: 10 }} severity="error">{generalErrorText}</Alert> : null}
                {sendConfirmationEmailDialog.success ? <Alert style={{ marginTop: 10 }} severity="success"></Alert> : null}

                <Typography variant="subtitle1">{t("SendConfirmationEmailSubtitle")}</Typography>

                <div style={{ maxWidth: 300, marginTop: 20, marginBottom: 20 }}>

                    <FormControl fullWidth style={{ marginTop: 10 }}>
                        <TextField
                            disabled
                            fullWidth
                            type="text"
                            value={webAccountUser.email}
                            label={t("EMail")}
                        />
                    </FormControl>
                </div>
                
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={() => dispatch(openSendConfirmationEmailDialog(false))} color="primary">
                    {t("Cancel")}
                </Button>
                <Button disabled={loading || sendConfirmationEmailDialog.success}
                    onClick={() => dispatch(sendConfirmationEmail(webAccountUser.id, history, location, token, unsetUser, t, language))}
                    color="primary">
                    {t("Submit")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SendWebAccountUserConfirmationEmailDialog;